import React from "react";

const badge = "text-[10px] font-medium tracking-widest uppercase px-2.5 py-1";

export function ProductBadges({ product }) {
  return (
    <div className="absolute left-3 top-3 flex flex-col gap-2">
      {product.on_sale && <span className={`${badge} bg-gold text-white`}>Sale</span>}
      {product.is_new && !product.on_sale && <span className={`${badge} bg-ink text-ivory`}>New</span>}
      {!product.available && <span className={`${badge} border border-ink/10 bg-white text-ink`}>Sold Out</span>}
    </div>
  );
}
